import { render, staticRenderFns } from "./MenuForText.vue?vue&type=template&id=0a06620c&scoped=true"
import script from "./MenuForText.vue?vue&type=script&lang=js"
export * from "./MenuForText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06620c",
  null
  
)

export default component.exports